import { AutogenModelEdierrorcodeList, AutogenRowEdierrorcodeList } from "./autogen/AutogenModelEdierrorcodeList";

export class ModelEdierrorcodeList extends AutogenModelEdierrorcodeList<RowEdierrorcodeList> {
	constructor() {
		super(RowEdierrorcodeList);
	}
}

export class RowEdierrorcodeList extends AutogenRowEdierrorcodeList {
}